import { readFragment, ResultOf } from "gql.tada";
import { ThemeModel } from "../../types/ThemeModel";
import { CurveCarouselSectionById } from "../../queries/entries/CurveCarouselSectionById";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import Carousel, { Slide } from "../shared/CurveCarousel";
import { LinkFragment } from "../../queries/fragments/LinkFragment";

export const CurveCarouselSection = ({
  entry: { curveCarouselSection: entry },
}: {
  entry: ResultOf<typeof CurveCarouselSectionById>;
}) => {
  const isDesktop = useIsDesktop();

  if (!entry?.itemsCollection?.items?.length) {
    return null;
  }
  const slides: Slide[] = entry.itemsCollection.items.map((item) => {
    return {
      content: item?.itemDescription ?? "",
      image: item?.image?.url,
      icon: item?.icon?.url,
      highlightTheme: item?.highlightTheme as ThemeModel,
      sourceInfo: item?.sourceInfo,
    } as Slide;
  });

  if (!slides?.length) {
    return null;
  }

  const ctaLink = readFragment(LinkFragment, entry?.ctaLink);

  return (
    <section className="flex flex-col gap-8 items-center justify-center dsk:py-20">
      <div className="w-full  min-h-screen flex justify-center items-center">
        <div className="min-h-max w-full">
          <Carousel
            ctaLink={ctaLink}
            slides={slides}
            slideWidth={isDesktop ? 564 : 280}
            slideHeight={isDesktop ? 500 : 250}
            gap={isDesktop ? 300 : 35}
            accessibilityControlLabelNext={entry.accessibilityControlLabelNext}
            accessibilityControlLabelPrevious={
              entry.accessibilityControlLabelPrevious
            }
          />
        </div>
      </div>
    </section>
  );
};
